export default __webpack_public_path__ + "static/media/more.ecb95605.svg";